import type { BanterCategory, BanterLine } from '../types.ts';

/** Wybiera linijkę żartów/pochwał deterministycznie po ziarnie (ta sama lekcja = ten sam dowcip). */
export function pickBanter(
  lines: readonly BanterLine[],
  category: BanterCategory,
  seed: number,
  step?: BanterLine['step'],
): BanterLine {
  const pool = lines.filter((l) => l.category === category && (step === undefined || l.step === step));
  if (pool.length === 0) throw new Error(`Brak linijek banter dla kategorii "${category}"${step ? ` / ${step}` : ''}`);
  return pool[Math.abs(Math.trunc(seed)) % pool.length] as BanterLine;
}
